module.exports = __webpack_public_path__ + "img/market_bg.4bc10eb1.png";